// 분류 타입
export const CATEGORY_TYPE_OPTIONS = [
  { value: 'folder', label: '폴더' },
  { value: 'text',   label: '텍스트' },
];

// 평가 공정 목록 (key: 저장값, value: 표시명)
export const PROCESS_LIST = {
  PRC001: '객실 내부 청소 및 기용품 세팅',
  PRC002: '오물 및 기용품 운반',
  PRC003: '차량/장비 이동',
  PRC004: '기내 책 교체',
  PRC005: '사무업무',
};

// process_list 저장값(^구분) → 표시명 배열
export function parseProcessList(processListStr) {
  if (!processListStr) return [];
  return processListStr.split('^').filter(Boolean).map(k => PROCESS_LIST[k] || k);
}

export const STRENGTH_OPTIONS = [
  { value: '', label: '선택' },
  { value: 3, label: '대 (3)' },
  { value: 2, label: '중 (2)' },
  { value: 1, label: '소 (1)' },
];

export const FREQUENCY_OPTIONS = [
  { value: '', label: '선택' },
  { value: 3, label: '상 (3)' },
  { value: 2, label: '중 (2)' },
  { value: 1, label: '하 (1)' },
];

// 위험성 = 빈도 × 강도
export function calcRiskLevel(frequency, strength) {
  const f = Number(frequency);
  const s = Number(strength);
  if (!f || !s) return null;
  return f * s;
}

// 위험성 레이블: 1|2→낮음, 3|4→보통, 6|9→높음
export function getRiskLevelLabel(level) {
  if (level === null || level === undefined || level === '') return '-';
  const n = Number(level);
  if (n <= 2) return '낮음';
  if (n <= 4) return '보통';
  return '높음';
}

// 위험성 뱃지 CSS 클래스
export function getRiskLevelClass(level) {
  if (level === null || level === undefined || level === '') return 'secondary';
  const n = Number(level);
  if (n <= 2) return 'success';
  if (n <= 4) return 'warning';
  return 'danger';
}
